import React, { useState, useEffect, useRef } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle menu item click
  const handleNavClick = (path) => {
    // Close the mobile menu
    setExpanded(false);

    // Navigate to the path
    navigate(path);
  };

  // Function to handle link click (for external links or different behavior)
  const handleLinkClick = () => {
    setExpanded(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    if (expanded) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [expanded]);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      className={`navbar-custom ${scrolled ? 'scrolled' : ''}`}
      ref={navbarRef}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => handleLinkClick()}>
          <div className="d-flex align-items-center">
            <img
              src="/images/golf-logo.png"
              alt="Golf4International Logo"
              style={{
                height: '60px',
                width: 'auto',
                maxWidth: '200px'
              }}
            />

          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(!expanded)}
          aria-label="Toggle navigation"
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link
              as={Link}
              to="/"
              className="nav-link-custom"
              onClick={() => handleNavClick('/')}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/services"
              className="nav-link-custom"
              onClick={() => handleNavClick('/services')}
            >
              Services
            </Nav.Link>
            <Nav.Link
  as={Link}
  to="/tournament"
  className="nav-link-custom"
  onClick={() => handleNavClick('/tournament')}
>
  Tournament
</Nav.Link>
            <Nav.Link
              as={Link}
              to="/academy"
              className="nav-link-custom"
              onClick={() => handleNavClick('/academy')}
            >
              Academy
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/about"
              className="nav-link-custom"
              onClick={() => handleNavClick('/about')}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/blog"
              className="nav-link-custom"
              onClick={() => handleNavClick('/blog')}
            >
              Blog
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className="contact-button btn-gold ms-lg-3 mt-2 mt-lg-0"
              onClick={() => handleNavClick('/contact')}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;